import { PureComponent } from 'react';
import onContainerClick from '../../../../pages/prescriptionPad/onClickContainer';
import PadV2PxElementCard from './padV2/PadV2PxElementCard';
import { BedFilledIcon } from '../../../common/Icons';
import { IpdAdmission, Procedure } from '../../../../store/types/prescription';
import { connect } from 'react-redux';
import { GlobalState } from '../../../../store/reducers';
import {
    getElementsFromPrescription,
    getIpdAdmission,
} from '../../../../store/selectors/prescriptionPad';
import { ThunkDispatch } from 'redux-thunk';
import { Actions } from '../../../../store/actions';
import { upsertIpdAdmission } from '../../../../store/actions/prescriptionPad';
import { Checkbox } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { getGenieSetting } from '../../../../store/selectors/session';

interface Props {
    dispatch: ThunkDispatch<GlobalState, null, Actions>;
    ipdAdmission?: IpdAdmission;
    procedures?: Procedure[];
    admissionToIPDEnabled: boolean;
}

class AdmissionToIPD extends PureComponent<Props> {
    bedFilledIcon = BedFilledIcon('w-16 h-12 fill-white transform scale-125');

    handleAdvisedChange = () => {
        const { dispatch, ipdAdmission } = this.props;
        const advised = ipdAdmission?.advised;
        dispatch(upsertIpdAdmission({ ...ipdAdmission, advised: !advised }));
    };

    handleIncludeProceduresChange = () => {
        const { dispatch, ipdAdmission } = this.props;
        const includeProcedures = ipdAdmission?.include_procedures;
        dispatch(upsertIpdAdmission({ ...ipdAdmission, include_procedures: !includeProcedures }));
    };

    handleNotesChange = (notes?: string) => {
        const { dispatch, ipdAdmission } = this.props;
        dispatch(upsertIpdAdmission({ ...ipdAdmission, notes: notes }));
    };

    render() {
        const { ipdAdmission, procedures, admissionToIPDEnabled } = this.props;
        const {
            bedFilledIcon,
            handleAdvisedChange,
            handleIncludeProceduresChange,
            handleNotesChange,
        } = this;

        const advised = ipdAdmission?.advised;
        const includeProcedures = ipdAdmission?.include_procedures;
        const notes = ipdAdmission?.notes;
        const isProceduresAdded = procedures && procedures.length > 0;

        if (!admissionToIPDEnabled) {
            return null;
        }

        return (
            <div
                key="admission-to-ipd"
                id="admission-to-ipd"
                onFocus={onContainerClick}
                className="flex overflow-hidden h-296 child"
            >
                <PadV2PxElementCard
                    icon={bedFilledIcon}
                    headingText={'Admission to IPD'}
                    iconContainerBgClassName="bg-darwin-accent-dark-blue-800"
                    bodyCssClassName="space-y-8 rounded-8 h-full"
                    renderHeaderRight={() => (
                        <Checkbox
                            onChange={handleAdvisedChange}
                            checked={advised}
                            className="transform scale-110"
                        >
                            Advised
                        </Checkbox>
                    )}
                >
                    <p className="pl-2">
                        <Checkbox
                            checked={includeProcedures}
                            onChange={handleIncludeProceduresChange}
                            disabled={!advised}
                        >
                            <p>
                                Add procedures{' '}
                                {`${
                                    isProceduresAdded && Array.isArray(procedures)
                                        ? `(${procedures.length})`
                                        : ''
                                }`}
                            </p>
                            {isProceduresAdded && Array.isArray(procedures) && (
                                <p className="text-13 text-darwin-neutrals-600 truncate-overflow-1">
                                    {procedures.map((i) => i.name).join(', ')}
                                </p>
                            )}
                        </Checkbox>
                    </p>
                    <TextArea
                        rows={isProceduresAdded ? 8 : 9}
                        className="ml-2 pt-8 pl-12 resize-none rounded-8"
                        defaultValue={notes}
                        onBlur={(e) => handleNotesChange(e.target.value)}
                        placeholder="Add admission notes here.."
                        disabled={!advised}
                    />
                </PadV2PxElementCard>
            </div>
        );
    }
}

export default connect((state: GlobalState) => ({
    ipdAdmission: getIpdAdmission(state),
    procedures: getElementsFromPrescription<Procedure>('procedures')(state),
    admissionToIPDEnabled: getGenieSetting(state, 'admissionToIPDEnabled') as boolean,
}))(AdmissionToIPD);
